var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"value":_vm.value,"width":"xl"},on:{"input":_vm.closeModal}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_c('Show',{attrs:{"id":_vm.order.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }